import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import store from "../../../../redux";
import './index.scss'
import {Button,Checkbox} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../servers/menuAPI";
import {refreshMenu} from "../../../../redux/common/action";
import { tableData } from './data'
import CTable from '@/components/CTable'

@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit= this.onSubmit.bind(this)
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    detaildata:[]
  }
  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'4.3',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      this.setState({
        dataSource:res.records,
      })
    })
  }

   onSubmit(){
    // gotonext()
    this.props.history.push({
      pathname: '/confirm/addauditProvince',
    });
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          <div className="import">
            <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource}>
              <div
                  slot='index'
                  render={(text, record, index) => (
                      <div className='operate'>
                        {index+1}
                      </div>
                  )} />
              <div
                  slot='suggest'
                  render={(text, record, index) => (
                      <div className='operate'>
                        {decodeURIComponent(record.notes)}
                      </div>
                  )} />
              <div
                  slot='jf'
                  render={(text, record, index) => (
                      <div className='operate'>
                        <Checkbox checked={record.checked}  onChange={(e)=>{this.onChange(e,index)}}>
                          建议减分
                        </Checkbox>
                      </div>
                  )} />
            </CTable>
          </div>
          {/*<div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>*/}
          {/*  <Button type="primary" className='yl' onClick={this.onSubmit}>下一步</Button>*/}
          {/*</div>*/}
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
